/**
 * DevExtreme (esm/__internal/scheduler/view_model/filtering/utils/get_appointment_filter/is_appointment_matched_intervals.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const isAppointmentMatchedIntervals = (_ref, intervals) => {
  let {
    startDate: startDate,
    endDate: endDate
  } = _ref;
  const intersectionIntervalIndex = intervals.findIndex(_ref2 => {
    let {
      max: max
    } = _ref2;
    return startDate < max;
  });
  if (-1 === intersectionIntervalIndex) {
    return false;
  }
  const intervalStartDate = intervals[intersectionIntervalIndex].min;
  return startDate >= intervalStartDate || endDate > intervalStartDate;
};